<template>
   <div class="top color" :style="{backgroundColor:boxBodyColor}">
      <!-- <img class="logo" src="../../assets/workorder/logo.png" /> -->
      <img  class="title_img" v-if="displayMode == 2" :src="logoUrl" alt="公司logo">
        <p  v-else class="title_2">
        <span v-if="companyName == '' || companyName==null"></span>

        <el-tooltip v-else-if="companyName.length > 10" :content="companyName" placement="top" effect="light">
          <span>{{companyName.substring(0,10) + '...'}}</span>
        </el-tooltip>

        <span v-else>{{companyName}}</span>
      </p>

      <span v-show="kefuis" @click="kefugo" style="margin-right:20px">在线客服</span>
      <img v-show="kefuis" @click="kefugo" class="kefu" height="18px" src="../../assets/workorder/kefu.png" />
      <span v-show="callis" @click="callgo" style="margin-right:40px">客服电话</span>
      <img  v-show="callis" @click="callgo" class="kefu1" height="18px" src="/pc/static/assets/callbtn.png" />
    </div>
</template>

<script>
import md5 from 'js-md5'
import * as Urls from '../url.js'
import axios from '@/utils/request.js'
export default {
  name:"top",
  data () {
    return {
      boxBodyColor:'',
      displayMode:'',
      logoUrl:'',
      companyName:'',
      kefuis:false,
      md5:'',
      basurl:Urls.baseurl,
      callis:false
    }
  },
  mounted(){
    var vm=this;
    vm.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    vm.companyName = sessionStorage.getItem('companyName');
    vm.logoUrl = sessionStorage.getItem('logoUrl');
    vm.displayMode = sessionStorage.getItem('displayMode');
    this.href= window.location.href.split("?")[1];
    this.md5=sessionStorage.getItem("md5");
    //判断客服是否显示
     axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
        if(response.data.code==1){
          vm.kefuis=true;
        }
     });

     if(sessionStorage.getItem('callCenterEnable') == 'true'){

        this.callis = true;
      }
  },
  methods: {
    callgo(){

      var userAgent = checkBrowser();
      var changeis = true;
      if(userAgent == '谷歌'){
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：'+banben)
        if(banben < 52){
          changeis = false;
        }
      }else{
        changeis = false;
      }
      if(changeis){
        window.location.href = '#/callcenter';
      }else{
        if(userAgent != "Safari"){
          this.$message({
            message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
            type: 'warning'
          })
        }else{
          alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
        }

      }


    },
     //判断跳转页面


    kefugo(){
        var vm=this;
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){
          //console.log(response)
          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus=="waiting"){
              vm.$router.replace({path: 'imLineUp'});
              //window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){
                vm.$router.replace({path: 'imSession'});
               //window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  //window.location.href="#/spirit";
                  vm.$router.replace({path: 'spirit'});
                  console.log('已经跳转了');
                }
                if(obj.target==2){
                  vm.$router.replace({path: 'imDirectory'});
                  //window.location.href="#/imDirectory";
                }
            }
          }
        })
    },


  }
}
</script>
<style scoped>
.top .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
.top .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin-left:20px;
}
.top .title_2 span{
  font-size: 16px
}
.top{
   height: 46px;
   width: 100%;
  position: relative;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: right;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
  position: absolute;
  right: 86px;
  margin-top: 13px;
 }
 .kefu1{
  margin-top: 13px;
 }
</style>



// WEBPACK FOOTER //
// src/components/workorder/top.vue?a91bcd06